export const loadingOverlay = {
  _id: 'loading-overlay',
  _messageClassName: 'loading-overlay-message',
  present: (message?: string, forceFullScreen?: boolean) => {
    if (typeof document === 'undefined') {
      return;
    }
    loadingOverlay._createIfNotExists();
    loadingOverlay._setMessage(message);
    loadingOverlay._backdropScroll(false);
    loadingOverlay._showAnimate();
    loadingOverlay._checkSizeForModal(forceFullScreen);
  },
  dismiss: () => {
    if (typeof document === 'undefined') {
      return;
    }
    loadingOverlay._backdropScroll(true);
    loadingOverlay._hideAnimate();
  },
  _createIfNotExists: () => {
    if (document.getElementById(loadingOverlay._id)) {
      return;
    }
    const div = document.createElement('div');
    div.id = loadingOverlay._id;
    div.className = 'hidden';
    div.innerHTML = `
      <style>
        #${loadingOverlay._id} {
          z-index: 999999999;
          position: fixed;
          background: rgba(255, 255, 255, 0.9);
          -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
          width: 100%;
          height: 100%;
          opacity: 1;
          visibility: visible;
          transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;
        }
        #${loadingOverlay._id}.hidden {
          opacity: 0;
          visibility: hidden;
        }
        #${loadingOverlay._id} .container {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        #${loadingOverlay._id} .container .${loadingOverlay._messageClassName} {
          color: #9E9E9E;
          padding: 20px 0;
        }
        #${loadingOverlay._id} .container img {
          animation-name: spinner;
          animation-duration: 2500ms;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
        }
        @keyframes spinner {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      </style>
      <div class="container">
        <img loading="lazy" src="assets/icons/spinner.svg" alt="">
        <div class="${loadingOverlay._messageClassName}"></div>
      </div>
    `;
    document.body.appendChild(div);
  },
  _setMessage: (message?: string) => {
    const textDiv = document.getElementsByClassName(loadingOverlay._messageClassName);
    if (textDiv) {
      textDiv[0].innerHTML = message || '';
    }
  },
  _backdropScroll(enable: boolean) {
    document.documentElement.style.overflow = enable ? 'auto' : 'hidden';
  },
  _showAnimate: () => {
    setTimeout(() => {
      const elm = document.getElementById(loadingOverlay._id);
      if (elm && elm.classList.contains('hidden')) {
        elm.classList.remove('hidden');
      }
    }, 1);
  },
  _checkSizeForModal: (forceFullScreen?: boolean) => {
    const elm = document.getElementById(loadingOverlay._id);
    if (elm) {
      const modal = document.getElementsByClassName('c-modal__box')[0];
      if (!modal || forceFullScreen === true) {
        elm.style.width = '100%';
        elm.style.height = '100%';
        elm.style.top = elm.style.left = elm.style.marginLeft = elm.style.marginTop = '0px';
      } else {
        const rect = modal.getBoundingClientRect();
        elm.style.width = rect.width + 'px';
        elm.style.height = rect.height + 'px';
        elm.style.top = elm.style.left = '50%';
        elm.style.marginLeft = -(rect.width / 2) + 'px';
        elm.style.marginTop = -(rect.height / 2) + 'px';
      }
    }
  },
  _hideAnimate: () => {
    setTimeout(() => {
      const elm = document.getElementById(loadingOverlay._id);
      if (elm && !elm.classList.contains('hidden')) {
        elm.classList.add('hidden');
      }
    }, 1);
  }
};
